<template>
  <v-card class="align-stretch" height="100%" :loading="creditNoteHistoryLoading">
    <v-card-title>
      Credit Notes History
      <v-spacer></v-spacer>
      <v-btn color="secondary" x-small @click="setCreateProposalOpen(true)"><v-icon small>add</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <v-data-table :headers="headers" :items="getCreditNoteHistory" disable-filtering disable-pagination disable-sort :hide-default-footer="true" @click:row="openDialog" :loading="creditNoteHistoryLoading">
        <template v-slot:item.created="{ item }"><span class="body--text">{{ item.created | formatDate }}</span></template>
        <template v-slot:item.agent="{ item }"><span class="body--text">{{ item.agent }}</span></template>
        <template v-slot:item.amount="{ item }"><span class="body--text">{{ item.amount | formatCurrency }}</span></template>
        <template v-slot:item.approval="{ item }"><span class="body--text">{{ item.approval }}</span></template>
      </v-data-table>
    </v-card-text>
    <CreditNoteActions :openActions="openActions" @closeDialog="openActions=false;" />
  </v-card>
</template>

<script>
  import CreditNoteActions from "@/components/CreditNotes/CreditNotesActions";
  import moment from 'moment';
  import { mapState,mapActions,mapMutations,mapGetters } from "vuex";

  export default {
    components: { CreditNoteActions },
    data: () => ({
      openActions: false,
      headers: [
        { text: 'Created',  value: 'created' },
        { text: 'Agent', value: 'agent' },
        { text: 'Amount', value: 'amount' },
        { text: 'Approval', value: 'approval' },
      ],
    }),

    filters: {
      formatDate(val) {
        if(!val) return "-";
        const date = new Date(val);
        return moment(date).format('YYYY-MM-DD');
      },
    },
    computed: {
      ...mapState('accounts', ['currentAccount','crmUsers']),
      ...mapState('creditnotes', ['creditNoteHistoryLoading']),
      ...mapGetters('creditnotes', ['getCreditNoteHistory']),
    },
    methods: {
      ...mapActions("creditnotes", ["setCreditNotesProposalsActionAccount"]),
      ...mapMutations("creditnotes", ["setCreateProposalOpen",]),
      openDialog(e) {
        this.setCreditNotesProposalsActionAccount(e);
        this.openActions = true;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
